import { atom } from "recoil";

export const formUpdated = atom({
  key: "formUpdated",
  default: {},
});
export const patientDetailsUpdated = atom({
  key: "patientDetailsUpdated",
  default: {},
});
